import { render, staticRenderFns } from "./delivery-note.vue?vue&type=template&id=05c8e80b"
import script from "./delivery-note.vue?vue&type=script&lang=js"
export * from "./delivery-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports